import React, { useEffect, useState } from "react";
import styles from "./Table.module.sass";
import Loader from "../../../components/Loader";
import Row from "./Row";
import Empty from "../../../components/Empty";
import { Pager } from "../../../components/Pager";
import Icon from "../../../components/Icon";
import Dropdown from "../../../components/Dropdown";
import tWallet from "../../../i11/TokenWallet";
import { useUser } from "../../../context";

const tokens = ["All Tokens", "PHYSICAL", "EXPERIENCE", "ART"];
const origins = ["Origin", "Direct Mint", "Trade-in"];
const statusL = ["N/A", "Listed", "Prize"];

const originSort = {
	"Direct Mint": "directMint",
	"Trade-in": "tradeIn",
};

const Table = ({
	items,
	isLoading,
	open,
	set_edit,
	type,
	setFilter,
	filter,
	getWallet,
	setPage_,
	closeC,
	...rest
}) => {
	const { locale } = useUser();
	const [sortingToken, setSortingToken] = useState(tokens[0]);
	const [sortOrigin, setSortOrigin] = useState(origins[0]);
	const [sortStatus, setSortStatus] = useState(statusL[0]);

	useEffect(() => {
		setSortingToken(tokens[0]);
	}, [type]);

	const sort = (name) => {
		setFilter((p) => {
			return {
				...p,
				order_by: name,
				order_direction:
					p.order_by === name ? (p.order_direction === 1 ? -1 : 1) : -1,
			};
		});
	};
	const onChangeToken = (value) => {
		setSortingToken(value);
		if (value !== sortingToken) {
			setPage_(1);
			setFilter((p) => {
				if (value === "All Tokens") {
					const tmp = { ...p };
					delete tmp["tokenType"];
					return tmp;
				}
				return {
					...p,
					tokenType: value + "_TOKEN",
				};
			});
		}
	};

	const onChangeOrigin = (value) => {
		setSortOrigin(value);
		if (value !== sortOrigin) {
			setPage_(1);
			setFilter((p) => {
				if (value === origins[0]) {
					const tmp = { ...p };
					delete tmp["origin"];
					return tmp;
				}
				return {
					...p,
					origin: originSort[value],
				};
			});
		}
	};

	const onChangeStatus = (value) => {
		setSortStatus(value);
		if (value !== sortStatus) {
			setPage_(1);
			setFilter((p) => {
				if (value === statusL[0]) {
					const tmp = { ...p };
					delete tmp["isPrize"];
					delete tmp["isOnSale"];
					return tmp;
				}
				const query = {
					isPrize: value === statusL[2],
					isOnSale: value !== statusL[2],
				};
				return {
					...p,
					...query,
				};
			});
		}
	};
	return (
		<div className={styles.wrapper}>
			<div className={styles.table}>
				<div className={styles.row}>
					<div className={styles.col}>{tWallet[locale].name}</div>
					<div className={styles.col}>{tWallet[locale].token_id}</div>
					<div className={styles.col}>
						<Dropdown
							className={styles.dropdown}
							classDropdownHead={styles.dropdownHead}
							value={sortingToken}
							setValue={onChangeToken}
							dictionary={tWallet[locale].tokensDic}
							options={tokens}
							small
						/>
					</div>
					{/* Origin */}
					<div className={styles.col}>
						<Dropdown
							className={styles.dropdown}
							classDropdownHead={styles.dropdownHead}
							value={sortOrigin}
							setValue={onChangeOrigin}
							dictionary={tWallet[locale].originDic}
							options={origins}
							small
						/>
					</div>
					<div className={styles.col}>
						<Dropdown
							className={styles.dropdown}
							classDropdownHead={styles.dropdownHead}
							value={sortStatus}
							setValue={onChangeStatus}
							dictionary={tWallet[locale].statusDic}
							options={statusL}
							small
						/>
					</div>
					<div className={styles.col} onClick={() => sort("createdAt")}>
						{tWallet[locale].date_mint}
						{filter.order_by === "createdAt" && (
							<Icon
								className={styles.icon_}
								name={
									filter.order_direction === 1 ? "arrow-top" : "arrow-bottom"
								}
								size="12"
							/>
						)}
					</div>
				</div>
				{items.map((x) => (
					<Row
						item={x}
						key={x._id}
						type={type}
						open={open}
						getData={getWallet}
					/>
				))}
			</div>
			{!isLoading && items.length === 0 && <Empty />}
			{isLoading && <Loader className={styles.loader} />}
			<div className={styles.foot}>
				<Pager {...rest} />
			</div>
		</div>
	);
};

export default Table;
